// extracted by mini-css-extract-plugin
export var addy = "about-module--addy--b5d6e";
export var block = "about-module--block--334e0";
export var block_caption = "about-module--block_caption--034b1";
export var block_copy = "about-module--block_copy--133a9";
export var block_image = "about-module--block_image--4e662";
export var block_img = "about-module--block_img--31d03";
export var block_stores = "about-module--block_stores--f8368";
export var cont = "about-module--cont--4fd61";
export var copy = "about-module--copy--b6bfb";
export var copy_body = "about-module--copy_body--c55b3";
export var date = "about-module--date--5295c";
export var dcbc = "about-module--dcbc--c05a3";
export var dcbcwr = "about-module--dcbcwr--eb000";
export var finput = "about-module--finput--15f62";
export var form = "about-module--form--31b45";
export var hero_desk = "about-module--hero_desk--dcaff";
export var hero_img = "about-module--hero_img--fdb69";
export var hero_mob = "about-module--hero_mob--8fcd1";
export var image = "about-module--image--fa5cb";
export var img = "about-module--img--7811e";
export var img_desk = "about-module--img_desk--c8f8d";
export var img_mobi = "about-module--img_mobi--0422d";
export var imgright = "about-module--imgright--f61fa";
export var msg = "about-module--msg--78a52";
export var nd_journTag = "about-module--nd_journ-tag--94fe6";
export var nhero = "about-module--nhero--44fdb";
export var overlay = "about-module--overlay--9f545";
export var sec = "about-module--sec--22c47";
export var subtitle = "about-module--subtitle--d19f0";
export var title = "about-module--title--c8295";
export var wide = "about-module--wide--c559c";